<template>
  <div class="login-container">
    <div class="login-weaper">
      <!-- 左侧介绍区域 -->
      <div class="login-tip">
        <div class="login-intro">
          <h1>smartcute广告交易平台</h1>
          <p class="slogan">智能竞价 · 高效变现 · 精准触达</p>
          <ul>
            <li>实时竞价，提升投放效率</li>
            <li>精准定向，触达目标用户</li>
            <li>安全透明，保障流量质量</li>
            <li>多维数据支持，优化投放策略</li>
          </ul>
        </div>
      </div>

      <!-- 右侧登录区域 -->
      <div class="login-border">
        <div class="login-main demo-dynamic">
          <el-form
            class="login-form"
            status-icon
            :rules="loginRules"
            ref="loginForm"
            :model="loginForm"
            label-width="0"
            size="small"
          >
            <el-form-item prop="username">
              <el-input
                v-model="loginForm.username"
                auto-complete="off"
                placeholder="请输入用户名"
              >
                <template #prefix>
                  <svg-icon :icon-class=icon1 style="font-size: 40px; margin-left: -12px; margin-top: -8px"></svg-icon>
<!--                  <i class="iconfont icon-steve"  />-->
                </template>
              </el-input>
            </el-form-item>

            <el-form-item prop="password">
              <el-input
                show-password
                v-model="loginForm.password"
                auto-complete="off"
                placeholder="请输入密码"
              >
                <template #prefix>
                  <svg-icon :icon-class=icon2 style="font-size: 28px;margin-left: -6px;margin-top: 2px"></svg-icon>
<!--                  <i class="iconfont icon-lock_fill" />-->
                </template>
              </el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="handleLogin" class="login-submit"

                         style="background: #48494a;
                          border: #AAA solid 2px;
                          outline: #101418 solid 2px;
                          padding: 0.5em calc(0.5em + 2px) ;
                         border-bottom: 5px solid #313233;">
                登录
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon'
import Vue from 'vue'
//环境不同显示的样式不同
if (process.env.NODE_ENV === "development"){
  import('@/styles/login2.scss')
}else if(process.env.NODE_ENV ==="production"){
  import('@/styles/login2.scss')
}else{
  import('@/styles/login.scss')
}

export default {
  components: { SvgIcon },
  name: 'login',
  props: {
    icon1: {
      type: String,
      default: 'steve'
    },
    icon2: {
      type: String,
      default: 'diamend'
    },
  },
  data () {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度最少为6位', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.$store.commit('SET_ACCESS_TOKEN', '')
  },
  methods: {
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.$store.dispatch('loginByUserName', this.loginForm).then(() => {
            this.$router.push({ path: '/' })
          })
        }
      })
    }
  }
}
</script>
